import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableGamesPerformanceReportsView.
 * @extends JetView
 */
export default class TableGamesPerformanceReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a value as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: 'datatable', // ID for the datatable
                            view: 'datatable', // Datatable view
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                // Column definitions
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 200,
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'TotalBets',
                                    header: _('Total de Apuesta'), // Localized header
                                    width: 200,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'TotalAward',
                                    header: _('Total de premios'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'TotalBonus',
                                    header: _('Total de bonificaciones'), // Localized header
                                    width: 250,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'TotalProgressiveSystemPrizes',
                                    header: _('Total de premios del sistema progresivo'), // Localized header
                                    width: 300,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'TotalReturns',
                                    header: _('Total de devoluciones'), // Localized header
                                    width: 250,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'TotalServiceFees',
                                    header: _('Total de comisiones por servicio'), // Localized header
                                    width: 250,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                                {
                                    id: 'RegistrationFees',
                                    header: _('Derechos de inscripción'), // Localized header
                                    width: 250,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat,
                                    exportType: 'number',
                                },
                            ],
                            on: {
                                // Event handlers for the datatable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay();
                                },
                            },
                            ready: function () {
                                // When the datatable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            autowidth: false, // Disable automatic width
                            math: true, // Enable math operations
                            datafetch: 10, // Number of records to fetch at a time
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        let url = devConfig.geturlApi() + 'es/Financial/GetConsolidatedIncomeOwnerSports'; // API URL

        // Event listener for filtering data
        this.on(this.app, 'consolidatedIncomeOwner:filter', (filterData) => {
            let object = Object.entries(filterData); // Convert filter data to entries
            let string1 = ''; // Query string for filters

            for (let i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        let date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                let date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        let object2 = Object.entries(object[i][1]);
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    let d = new Date(object2[j][1]);
                                    let dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        let d = new Date(object2[j][1]);
                                        let dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data
            $$('consultDesk').define('disabled', true); // Disable consult desk during loading
            grid.load(url + '?ChangeDate=1&start=0&count=' + grid.data.$pagesize + string1) // Load data with filters
                .then((response) => {
                    $$('consultDesk').define('disabled', false); // Re-enable consult desk after loading
                })
                .catch((e) => {
                    $$('consultDesk').define('disabled', false); // Re-enable consult desk on error
                });
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for pagination
        $$('pagerA').attachEvent('onAfterPageChange', function (page) {
            webix.delay(
                function () {
                    if (page != '0') {
                        chargeTable(); // Load data for the new page
                    }
                },
                '',
                '',
                100,
            );
        });

        // Event listener for size change
        this.on(this.app, 'changeSize', (filterData) => {
            chargeTable(); // Reload table on size change
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get page size
            let page = grid.getPage(); // Get current page
            let first = size * page; // Calculate first record index
            let last = first + size - 1; // Calculate last record index
            grid.load(url + '?start=' + first + '&count=' + (last + 1) + filter); // Load data for the current page
        }
    }
}

// FILE DOCUMENTED
